import React, {useEffect, useState} from "react";
import { TriangleAlert } from "lucide-react";

import MyJourneyFile from "../../assets/my_journey_blank_scroll.png";
import LocalStorageDataStorer from './../../dataAccessLayer/localStorage/LocalStorageDataStorer';
import LocalStorageKey from './../../dataAccessLayer/localStorage/LocalStorageKey';


export default function MyJourneySection(){
    const [_dominantCharacters, setDominantCharacters] = useState([]);
    const [_activeDominantCharacters, setActiveDominantCharacters] = useState(false);

    useEffect(()=>{
        const twoDominantCharacterTypes = getTwoDominantCharacterTypes();
        if(twoDominantCharacterTypes.length > 0){
            setDominantCharacters(twoDominantCharacterTypes);
            setActiveDominantCharacters(true);
            return 
        }
    }, []);


    function getTwoDominantCharacterTypes(){
        let allChallenges = [];
        const twoDominantCharacterTypes = LocalStorageDataStorer.getItemFromLocalStorage(LocalStorageKey.mostTwoDominantCharacterTypes);
        if(twoDominantCharacterTypes){
            
            for(let i = 0; i< twoDominantCharacterTypes.length; i++){
                const profile = twoDominantCharacterTypes[i];
                const challenges = profile.profileData.challenges.enumeration;
                for(let a = 0; a < challenges.length; a++){
                    allChallenges.push(challenges[a]);
                }
            }
        }

        return allChallenges;
    }

    return (
    <>
        <div className="journey-image-container flex-column-items-center">
            <img src={MyJourneyFile} alt="my_journey" className="background-image"/>
            <div id="transparent-layer1" className='transparent-overlay-flex'>
                <div className="journey-container flex-column-items-center">                    
                    <div className="growth-opportunity-column">
                        {!_activeDominantCharacters &&<>
                         <h3 className="initial-message"> Please complete the questionnaire to learn about the challenges in your journey to <strong>THE BEST LIFE YOU WANT</strong>.</h3>
                        </>}
                        { _activeDominantCharacters && <>
                            <h1 className="header-title">Your roadmap to breakthrough</h1>
                            <h3 className="challenge-message">"Master these <strong>challenges</strong> to align your frequency with your ultimate goals and get <strong>THE BEST LIFE YOU WANT</strong>."</h3>
                        </>}
                        <div className="challenge-container-items flex-column-items-center">
                            <ul className="unordered-list-container">
                                {_dominantCharacters.map((challenge, index)=>(
                                <li key={challenge} className="list-item challenge-item-container-grid">                                      
                                    <TriangleAlert className="font-color-red danger-icon"/> 
                                    <span className="challenge-item">{challenge}</span>
                                </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>                
        </div>        
    </>
    )
}